import { FC } from 'react';
import { Image, Skeleton } from "antd";
import { SettingFilled } from "@ant-design/icons";

import useInfoScreen from '../../useInfoScreen';
import profile from '../../images/profile.png';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenButton } from "../ScreenButton";
import { ScreenLayout } from "../ScreenLayout";
import styles from './index.module.scss';

export const ProfileScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return (
    <ScreenLayout
      header={(
        <>
          <div className={styles.title}>
            Профиль
          </div>
          <SettingFilled style={{ fontSize: 18 }} />
        </>
      )}
    >
      <Image
        width={168}
        height={168}
        alt="profile"
        preview={false}
        src={profile}
      />
      <div className={styles.body}>
        <EditableContent type="body" maxLength={180} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          Войти
        </ScreenButton>
        <ScreenButton type="ghost">
          Зарегистрироваться
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  );
};